/**
 * POSŒNNOÏSME — KATÛPIRSIA 1 / AXIS
 * MOTEUR CHERCHEUR VÉRITABLE : CALCULATEUR DE SYNTONIE OPÉRATIVE
 * Ce script ne fait pas qu'afficher : il croise, calcule et module les concepts.
 */

(function () {
    "use strict";

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('mode') !== 'chercheur') return;

    let organonData = null;
    let currentLang = 'fr'; // Forcé en FR pour l'analyse opérative
    let flatItems = []; 

    // Lexique sous protection absolue (empêche la corruption par le navigateur)
    const LEXIQUE = ["Posœnnoïa", "Posœnnoïsme", "Posœnnoïal", "Axis", "RéZonans", "Péroptissimisme", "Aliœvolution", "Katûpirsia", "Àpákan", "Posœnnomia", "Katûvýsissence", "Pistis Chraomai", "Organon"];

    document.addEventListener("DOMContentLoaded", initialiserLaboratoire);

    async function initialiserLaboratoire() {
        injecterInterfaceOperative();
        await chargerMatrice();
    }

    // 1. INJECTION DE L'INTERFACE DE CALCUL (Le Laboratoire)
    function injecterInterfaceOperative() {
        const style = document.createElement('style');
        style.innerHTML = `
            #po-lab-matrix { display: grid; grid-template-columns: 320px 1fr; gap: 24px; font-family: 'Courier New', monospace; background: #0a0a0a; color: #e0e0e0; padding: 24px; margin: 2rem 0; border: 1px solid #333; }
            .po-lab-panel { background: #141414; border: 1px solid #2a2a2a; padding: 20px; border-radius: 8px; }
            .po-lab-panel h3 { color: #d4af37; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 2px; border-bottom: 1px solid #333; padding-bottom: 10px; margin-top: 0; }
            .notranslate { font-weight: bold; color: #d4af37; }
            .po-btn-concept { display: block; width: 100%; text-align: left; background: #1a1a1a; color: #aaa; border: 1px solid #333; padding: 10px; margin-bottom: 6px; cursor: pointer; transition: 0.3s; font-family: inherit; }
            .po-btn-concept:hover, .po-btn-concept.active { background: #d4af37; color: #000; border-color: #d4af37; }
            select.po-combo { width: 100%; padding: 12px; background: #0a0a0a; color: #d4af37; border: 1px solid #333; margin-bottom: 15px; font-family: inherit; outline: none; }
            #po-syntonie-calc { background: #050505; border-left: 3px solid #d4af37; padding: 20px; margin-top: 20px; min-height: 200px; }
            .po-calc-math { font-size: 0.85rem; color: #00ffcc; display: block; margin-top: 15px; padding-top: 15px; border-top: 1px dashed #333; }
            .po-pulse { animation: po-pulse 2s infinite; }
            @keyframes po-pulse { 0% { opacity: 1; } 50% { opacity: 0.6; } 100% { opacity: 1; } }
        `;
        document.head.appendChild(style);

        const container = document.createElement('div');
        container.id = 'po-lab-matrix';
        container.className = 'notranslate';
        container.setAttribute('translate', 'no');

        container.innerHTML = `
            <aside class="po-lab-panel">
                <h3>Explorateur d'Axis</h3>
                <input type="text" id="po-search-node" placeholder="Filtrer le flux..." style="width:100%; padding:10px; background:#000; color:#fff; border:1px solid #333; margin-bottom:15px; font-family:inherit;">
                <div id="po-nodes-tree"></div>
            </aside>
            <main class="po-lab-panel">
                <h3>Syntonie Opérative (Loi du Tout avec Tout)</h3>
                <div style="display:flex; gap:15px;">
                    <select id="po-node-a" class="po-combo"><option value="">-- Flux A --</option></select>
                    <select id="po-node-b" class="po-combo"><option value="">-- Flux B --</option></select>
                </div>
                <div id="po-syntonie-calc">
                    <p style="color:#666;">En attente de croisement vibratoire...</p>
                </div>
            </main>
        `;

        const targetNode = document.querySelector('main') || document.body;
        targetNode.prepend(container);
    }

    // 2. INGESTION DE LA MATRICE JSON
    async function chargerMatrice() {
        try {
            const urlJSON = document.getElementById('po-k1-axis-research-shell')?.getAttribute('data-po-json-url') || 'po-k1-axis-research-mode-texts-fr-en-es-20260314.json';
            const response = await fetch(urlJSON);
            const data = await response.json();
            organonData = data.fr; 
            
            aplatirMatrice();
            peuplerExplorateur();
            peuplerCombinaison();
            activerRecherche();
        } catch (e) {
            console.error("Erreur Posœnnoïale : JSON introuvable.", e);
            document.getElementById('po-syntonie-calc').innerHTML = `<p style="color:red;">Rupture de flux : Impossible de charger le corpus JSON.</p>`;
        }
    }

    function aplatirMatrice() {
        const groupes = organonData.groups;
        for (const [key, group] of Object.entries(groupes)) {
            group.items.forEach(item => {
                flatItems.push({
                    id: item.title.fr,
                    type: item.kicker.fr,
                    data: item
                });
            });
        }
    }

    function peuplerExplorateur(filtre = "") {
        const tree = document.getElementById('po-nodes-tree');
        tree.innerHTML = "";
        flatItems.forEach(item => {
            if (filtre && !item.id.toLowerCase().includes(filtre)) return;
            const btn = document.createElement('button');
            btn.className = 'po-btn-concept';
            btn.innerHTML = `<strong style="color:#fff;">${proteger(item.id)}</strong><br><span style="font-size:0.75rem;">${item.type}</span>`;
            tree.appendChild(btn);
        });
    }

    function peuplerCombinaison() {
        const selA = document.getElementById('po-node-a');
        const selB = document.getElementById('po-node-b');
        flatItems.forEach(item => {
            selA.add(new Option(`[${item.type}] ${item.id}`, item.id));
            selB.add(new Option(`[${item.type}] ${item.id}`, item.id));
        });

        selA.addEventListener('change', calculerMoteur);
        selB.addEventListener('change', calculerMoteur);
    }

    function activerRecherche() {
        document.getElementById('po-search-node').addEventListener('input', (e) => {
            peuplerExplorateur(e.target.value.toLowerCase());
        });
    }

    // 3. LE CŒUR OPÉRATIF : ALGORITHME DE SYNTONIE
    function calculerMoteur() {
        const valA = document.getElementById('po-node-a').value;
        const valB = document.getElementById('po-node-b').value;
        const output = document.getElementById('po-syntonie-calc');

        if (!valA || !valB) return;

        const objA = flatItems.find(i => i.id === valA);
        const objB = flatItems.find(i => i.id === valB);

        // Extraction des Nombres-Guides depuis le JSON
        const numA = extraireNombreGuide(objA);
        const numB = extraireNombreGuide(objB);
        const foncA = extraireFonction(objA);
        const foncB = extraireFonction(objB);

        if (valA === valB) {
            output.innerHTML = `
                <h4 style="color:#d4af37; font-size:1.2rem; margin:0 0 10px 0;">RÉSONANCE INTERNE : ${proteger(valA)}</h4>
                <p><strong>Repli vibratoire :</strong> L'élément intensifie sa propre nature.</p>
                <p><em>${proteger(foncA)}</em></p>
                <div class="po-calc-math">Masse de l'axe : Nombre-guide [${numA}]</div>
            `;
            return;
        }

        // --- CALCULS POSŒNNOÏAUX DE SYNTONIE ---
        // Réduction théosophique de la somme des nombres-guides
        let somme = numA + numB;
        let racineVibratoire = reduireNombre(somme);
        
        let typeInteraction = determinerInteraction(objA.type, objB.type);

        output.innerHTML = `
            <h4 style="color:#d4af37; font-size:1.2rem; margin:0 0 15px 0;">SYNTONIE ACTIVE : <span style="color:#fff;">${proteger(valA)}</span> ↔ <span style="color:#fff;">${proteger(valB)}</span></h4>
            <p style="margin-bottom:8px;"><strong>Nature de l'Interaction :</strong> ${typeInteraction}</p>
            
            <div style="padding:15px; background:#111; border:1px solid #333; margin-top:15px;">
                <p style="margin:0 0 10px 0; color:#aaa;"><strong>Modulation générée :</strong></p>
                <p style="margin:0;">L'axe de <em>[${proteger(foncA)}]</em> est percuté par l'impératif de <em>[${proteger(foncB)}]</em>.</p>
                <p style="margin-top:10px; color:#d4af37;">Cette collision oblige l'Organon à ouvrir une nouvelle voie d'Adaptabilité.</p>
            </div>

            <div class="po-calc-math po-pulse">
                &gt; CALCUL VIBRATOIRE EN COURS...<br>
                &gt; V(A) = ${numA} | V(B) = ${numB}<br>
                &gt; Synthèse brute (A+B) = ${somme}<br>
                &gt; Racine Résonnante de l'Interaction = <strong>${racineVibratoire}</strong> (${interpreterRacine(racineVibratoire)})
            </div>
        `;
    }

    // --- FONCTIONS MATHÉMATIQUES DU POSŒNNOÏSME ---

    function extraireNombreGuide(obj) {
        if (!obj.data.stats) return 0;
        let stat = obj.data.stats.find(s => s.k.fr === "Nombre-guide");
        if (!stat) return 0;
        // Gérer le cas de "1622" ou "11 -> 2"
        let val = stat.v.fr.replace(/[^0-9]/g, ''); 
        return parseInt(val.substring(0, 4)) || 0;
    }

    function extraireFonction(obj) {
        if (obj.data.stats) {
            let stat = obj.data.stats.find(s => s.k.fr === "Fonction");
            if (stat) return stat.v.fr;
        }
        return obj.data.kind.fr;
    }

    // Réduction (ex: 22 + 11 = 33 => 3+3 = 6)
    function reduireNombre(num) {
        if (num === 0) return 0;
        let sum = num;
        while (sum > 9 && sum !== 11 && sum !== 22) { // 11 et 22 sont des maîtres nombres
            sum = sum.toString().split('').reduce((a, b) => parseInt(a) + parseInt(b), 0);
        }
        return sum;
    }

    // Interprétation sémantique de la racine
    function interpreterRacine(racine) {
        const significations = {
            1: "Origine / Impulsion nouvelle",
            2: "Friction / Association",
            3: "Création / Pluralité d'expression",
            4: "Enracinement / Matérialisation",
            5: "Mouvement / Crise transformatrice",
            6: "Harmonie / Illusion dévoilée",
            7: "Anamnèse / Profondeur analytique",
            8: "Superposition / Puissance d'agencement",
            9: "Achèvement / Instantané total",
            11: "Lucidité pure / Tension de relance",
            22: "Résonance Maîtresse / Ouverture totale"
        };
        return significations[racine] || "Modulation asymétrique";
    }

    // Logique relationnelle
    function determinerInteraction(typeA, typeB) {
        if (typeA === "Pilier" && typeB === "Pilier") return "Tension Structurelle (Ajustement de l'assise).";
        if (typeA === "Outil" && typeB === "Outil") return "Complexification Cognitive (Amplification des perspectives).";
        if (typeA === "Engrenage" && typeB === "Engrenage") return "Paradoxe Mécanique (Lutte entre l'accumulation et l'épure).";
        if ((typeA === "Pilier" && typeB === "Outil") || (typeA === "Outil" && typeB === "Pilier")) return "Application Active (L'énergie du Pilier s'incarne dans la forme de l'Outil).";
        if ((typeA === "Engrenage" && typeB === "Pilier") || (typeA === "Pilier" && typeB === "Engrenage")) return "Régulation Énergétique (L'engrenage accélère ou freine la racine du Pilier).";
        return "Transversalité (Ouverture vers les annexes et l'Organon global).";
    }

    function proteger(texte) {
        let txt = texte;
        LEXIQUE.forEach(mot => {
            const regex = new RegExp(`\\b(${mot})\\b`, 'gi');
            txt = txt.replace(regex, `<span class="notranslate" translate="no">$1</span>`);
        });
        return txt;
    }

})();
